import request from '@/utils/httpClient'
import { PaginationRequest } from '@/model/PaginationRequest'
import { Pagination } from '@/model/Pagination'

export default class Api {
  constructor(private readonly url: string) {
  }

  create<D>(data: D): Promise<void> {
    return request({
      url: this.url,
      method: 'POST',
      data
    })
  }

  update<D>(id: number, data: D): Promise<void> {
    return request({
      url: `${this.url}/${id}`,
      method: 'PUT',
      data
    })
  }

  findById<D>(id: number): Promise<D> {
    return request({
      url: `${this.url}/${id}`,
      method: 'get'
    })
  }

  deleteByIds(ids: string): Promise<void> {
    return request({
      url: `${this.url}/${ids}`,
      method: 'delete'
    })
  }

  deleteByIdArray(ids: Array<number>): Promise<void> {
    return this.deleteByIds(ids.join(','))
  }

  page<D>(params?: PaginationRequest): Promise<Pagination<D>> {
    return request({
      url: `${this.url}/page`,
      method: 'get',
      params
    })
  }
}
